import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import * as apiUrl from "../../apiUrl";
function WhyMarquisBanner({ data }) {
  return (
    <div
      className="common-banner-sec whymarquis-banner"
      style={{
        backgroundImage: `url(${apiUrl.apiUrl + `/` + data.banner_image})`,
      }}
    >
      <Container fluid>
        <Row className="banner-text-center">
          <Col md={4}>
            <div className="banner-text-topspace">
              <h1 className="common-head whiteColor"> {data.banner_title}</h1>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default WhyMarquisBanner;
